import { render, staticRenderFns } from "./dynamic-fields-tab.vue?vue&type=template&id=3da8c2d6"
import script from "./dynamic-fields-tab.vue?vue&type=script&lang=js"
export * from "./dynamic-fields-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports